/* eslint-disable no-nested-ternary */
import React from 'react';
import { Translate } from 'react-redux-i18n';

import PurchasesUtils from '../../../app/utils/purchases';
import PurchaseData from '../../../data/translate';

const WizzardOrdersComponent = ({
  order, easyConfirm, companyTag, easyConfirmVersion,
}) => {
  let step = PurchasesUtils.getStatus(order.status);
  if (companyTag === 'nortel') {
    const occurrences = (order.invoice && order.invoice[0] && order.invoice[0].occurrences) || {};
    if (order.isDeliveryClient === '1') {
      if (order.status === 'invoces_issued') {
        step = 4;
      } else if (order.status === 'invoces_issued_partially') {
        step = 3;
      }
    }

    if (easyConfirm && occurrences) {
      let dataCriacao = '';
      let dataPrevisao = '';
      let dataEntrega = '';

      if (easyConfirmVersion && easyConfirmVersion >= '3.0') {
        dataCriacao = (occurrences.dataCriacao) ? occurrences.dataCriacao : '';
        dataPrevisao = (occurrences.embarque && occurrences.embarque.dataReprogramada) ? occurrences.embarque.dataReprogramada.$
          : (occurrences.dataPrevisao) ? occurrences.dataPrevisao : '';
        dataEntrega = (occurrences.embarque && occurrences.embarque.dataEntrega) ? occurrences.embarque.dataEntrega.$
          : (occurrences.entrega && occurrences.entrega.dataEntrega) ? occurrences.entrega.dataEntrega : '';
      } else if (occurrences.embarque) {
        dataCriacao = (occurrences.embarque.dataCriacao) ? occurrences.embarque.dataCriacao.$ : '';
        dataPrevisao = (occurrences.embarque.dataPrevisao) ? occurrences.embarque.dataPrevisao.$ : '';
        dataEntrega = (occurrences.embarque.dataEntrega) ? occurrences.embarque.dataEntrega.$ : '';
      }

      if (dataEntrega) {
        step = 4;
      } else if (dataCriacao || dataPrevisao) {
        step = 3;
      }
    }
  }

  if (companyTag === 'nortel' && order.status === PurchaseData.orderStatus.CANCELED) {
    return (
      <div className="order-detail-all align-center">
        <ul className="checkout-progress-bar">
          <li className="active">
            <span><Translate value="orderDone" /></span>
            <i className="fas fa-clipboard-check" />
          </li>
          <li className="active">
            <span style={{ color: 'red' }}><Translate value="canceled" /></span>
            <i className="fas fa-ban" style={{ color: 'red' }} />
          </li>
        </ul>
      </div>
    );
  }
  return (
    <div className="order-detail-all align-center">
      <ul className="checkout-progress-bar">
        <li className={step >= 0 ? 'active' : ''}>
          <span><Translate value="orderDone" /></span>
          <i className="fas fa-clipboard-check" />
        </li>
        <li className={step >= 1 ? 'active' : ''}>
          <span><Translate value="paymentDone" /></span>
          <i className="fas fa-dollar-sign" />
        </li>
        <li className={step >= 2 ? 'active' : ''}>
          <span><Translate value="invoiceDone" /></span>
          <i className="fas fa-copy" />
        </li>
        {easyConfirm && (
          <React.Fragment>
            <li className={step >= 3 ? 'active' : ''}>
              <span><Translate value="inTransport" /></span>
              <i className="fas fa-truck" />
            </li>
            <li className={step >= 4 ? 'active' : ''}>
              <span><Translate value="orderDelivered" /></span>
              <i className="fas fa-check-circle" />
            </li>
          </React.Fragment>
        )}
      </ul>
    </div>
  );
};

export default WizzardOrdersComponent;
